const IDLE_TIMEOUT_MS = 5000;

type TConnection = { saveData?: boolean };

const noop = () => undefined;

/**
 * Starts the given imports when the browser has nothing else to do, so heavy parts of forms (a
 * timezone database, a phone-number parser) are in the cache before a modal asks for them. A
 * failed fetch is ignored: the code is fetched again, and the failure reported, when it is needed.
 * Nothing is fetched when the user asked the browser to save data. Returns a cancel function.
 */
const prefetchWhenIdle = (loaders: Array<() => Promise<unknown>>) => {
  const connection = (navigator as Navigator & { connection?: TConnection }).connection;

  if (connection?.saveData) {
    return noop;
  }

  const run = () => loaders.forEach(load => load().catch(noop));

  if ('requestIdleCallback' in window) {
    const handle = window.requestIdleCallback(run, { timeout: IDLE_TIMEOUT_MS });

    return () => window.cancelIdleCallback(handle);
  }

  // Safari has no requestIdleCallback
  const handle = setTimeout(run, IDLE_TIMEOUT_MS);

  return () => clearTimeout(handle);
};

export default prefetchWhenIdle;
